<template>
    <div class="index notranslate">
        <v-header :is-seft="0"></v-header>

        <!-- cart content -->
        <mu-container class="content" style="padding-left:0px;padding-right:0px;overflow-y:auto;padding-bottom:60px;" v-show="!showOrderTip">
            <div class="ower">
                <span class="badge-num" :class="{select:current==-1}" @click="selectOwerCartlist(-1,null)">{{$t('orderList.all')}}</span>
                <span class="badge-num" :class="{select:index==current}" @click="selectOwerCartlist(index,val)" v-for="(val, key, index) in cartOwerData" :key="index">{{key.replace(/\"/g,"")}}</span>
            </div>
            <div class="cart-box" v-for="(val, key, index) in cartShowData" :key="index">
                <mu-list>
                    <mu-list-item style="height:36px;">
                        <mu-list-item-content>
                            <mu-list-item-title class="table-info-list-title">{{key.replace(/\"/g,"")}}</mu-list-item-title>
                        </mu-list-item-content>
                    </mu-list-item>
                    <mu-divider></mu-divider>
                    <mu-list-item style="height:50px;margin:10px auto;" v-for="item,index in val" :key="index">
                        <mu-flex class="flex-wrapper">
                            <img :src="getImgUrl(item.foodImage,100)" style="border-radius:0;width:60px;height:40px;"/>
                            <div style="margin-left: 10px;height:40px;width:100%;float:left;">
                                <div style="float:left;">
                                    <div style="font-size:12px;height:12px;line-height:12px;width:100%;">
                                        {{item.foodName}}
                                    </div>
                                    <div style="font-size:12px;height:12px;line-height:12px;width:100%;max-width: 200px;" v-if="item.decideName!=null && item.decideName!=''">
                                        {{item.decideName}}
                                    </div>
                                    <div style="margin-top:10px;" v-if="item.chargedOnce==1">
                                        <span class="now">{{Number(1 * item.price).toFixed(0)}} {{seller.unit}}</span><span v-show="item.foodDiscount!=1" class="old">{{Number(1 * item.price)}}  {{seller.unit}}</span>
                                    </div>
                                    <div style="margin-top:10px;" v-else>
                                        <span class="now">{{Number(item.quantity * item.price).toFixed(0)}} {{seller.unit}}</span><span v-show="item.foodDiscount!=1" class="old">{{Number(item.quantity * item.price)}}  {{seller.unit}}</span>
                                    </div>
                                </div>
                                <div class="cart-opration notranslate">
                                    <mu-button class="cart-opration-btn" @click="cartOpration(item,'reduce')" style="padding:0;" >
                                        <mu-icon value="remove" style="font-weight: 600;font-size:14px;"></mu-icon>
                                    </mu-button>
                                    <mu-button class="cart-opration-quantity" style="padding:0;">
                                        <div style="font-size:12px;font-weight: 500;">{{item.quantity}}</div>
                                    </mu-button>
                                    <mu-button class="cart-opration-btn" @click="cartOpration(item,'add')"  :disabled="true" :class="(payClass===true||item.unAdd)?'form-onlyread':''" style="padding:0;">
                                        <mu-icon value="add" style="font-weight: 600;font-size:14px;"></mu-icon>
                                    </mu-button>
                                </div>
                            </div>
                        </mu-flex>
                    </mu-list-item>
                </mu-list>
            </div>
            <mu-list>
                <mu-list-item style="height:40px;float:right;margin-bottom:10px;">
                    <mu-list-item-content style="font-size:18px;font-weight:600;">
                        {{$t('orderList.total')}}:<span style="color:#f01414;font-weight:600;"> {{allAmount}} {{seller.unit}}</span>
                    </mu-list-item-content>
                </mu-list-item>
            </mu-list>

            <!-- <mu-list style="background-color: #fff; height: 60px; padding-top: 20px; ">
                <mu-checkbox v-model="chkPromise" value="1" :label="configsData.DeliveryTimePrompt"></mu-checkbox>
            </mu-list> -->

            <mu-list style="padding-bottom:0px;background-color:#e0e0e0">
                    <mu-text-field multi-line :rows="3" label-float  :label="getSendKitchen()" :rows-max="6" v-model="tableOrderInfo.specielle" style="margin-bottom: 0px; background-color: #fdf6ec;font-size: 16px;width:100%;"></mu-text-field>
                    <diV v-if="tasteList.length>0"  >
                    <mu-button  style="margin: 5px;"  :key="index" @click="clickTaste(item)" v-for="(item,index) in tasteList" color="rgb(218, 91, 58)">   {{item.tasteName}} </mu-button>
                </diV>
            </mu-list>

            <div style="right:0;position:absolute;bottom:50px;" v-if="unPayTip!=''">
                <mu-chip class="demo-chip" key="1" color="error" @delete="removeTip(1)" delete>{{unPayTip}}</mu-chip>
            </div>

            <div class="oprations" v-show="disFlag">
                <div class="oprations-btn">
                    <div class="oprations-back" @click="jumpBack">{{$t('common.back')}}</div>
                </div>
                <div class="oprations-btn">
                    <div class="oprations-next enough" @click="order">{{$t('common.submit')}}</div>
                </div>
            </div>
            <mu-dialog width="360" transition="slide-bottom" fullscreen :open.sync="openFullscreen">
                <mu-appbar color="primary" title="Edit info">
                    <mu-button slot="left" icon @click="closeFullscreenDialog">
                        <mu-icon value="close"></mu-icon>
                    </mu-button>
                    <mu-button slot="right" flat @click="closeFullscreenDialog">
                        {{$t('common.save')}}
                    </mu-button>
                </mu-appbar>
                <div style="padding: 24px;">
                    <mu-form class="mu-demo-form" label-width="100">
                        <mu-form-item prop="tableOrderInfo.name" label="Name">
                            <mu-text-field v-model="tableOrderInfo.name"></mu-text-field>
                        </mu-form-item>
                        <mu-form-item prop="tableOrderInfo.telephone" label="Telephone">
                            <mu-text-field v-model="tableOrderInfo.telephone"></mu-text-field>
                        </mu-form-item>
                        <mu-form-item prop="tableOrderInfo.child" label="Voksne">
                            <mu-text-field v-model="tableOrderInfo.child"></mu-text-field>
                        </mu-form-item>
                        <mu-form-item prop="tableOrderInfo.specielle" label="Specielle">
                            <mu-text-field multi-line :rows="3" :rows-max="6" v-model="tableOrderInfo.specielle"></mu-text-field>
                        </mu-form-item>
                    </mu-form>
                </div>
            </mu-dialog>

            <div style="background-color:#000;position:absolute;top:0;opacity:0.5;height:100%;width:100%;z-index:99999;color:#fff;text-align:center;" v-if="isLoading">
                <div v-loading="true" style="vertical-align:central;margin-top:60%;">
                </div>
                {{$t('orderList.orderSubmitted')}}
            </div>
        </mu-container>

        <div style="width: 100%; background: #fff; padding: 20px;text-align:center;padding-top:60px;" v-show="showOrderTip">
            <mu-flex class="flex-wrapper" justify-content="center">
                <div style="font-size:16px;font-weight:600;color:#DA5B3A;">{{$t('orderList.submitCart')}}</div>
            </mu-flex>
            <mu-flex class="flex-wrapper" justify-content="center">
                <div style="width: 100%; text-align: center; margin-top: 30px;"><mu-button color="success" class="notranslate" @click="jumpBack" style="text-transform:unset;">{{$t('orderList.return')}}</mu-button></div>
            </mu-flex>
        </div>

        <mu-dialog :title="$t('orderList.orderChangeTip')" width="360" :open.sync="openOrderChange" :overlay-close="false" :esc-press-close="false">
            {{$t('common.orderstatechange')}}
            <mu-button slot="actions" flat color="primary" @click="jumpOrderChange" style="color: #da5b3a;"> {{$t('common.sure')}}</mu-button>
        </mu-dialog>
    </div>
</template>
<script>
    import header from '../components/Header';
    export default {
        name: 'Cart',
        data() {
            return {
                docked: false,
                open: false,
                tableOrderInfo: {},
                refreshDisbale: false,
                cartList: [],
                cartShowData: {},
                cartOwerData: {},
                openFullscreen: false,
                allAmount: 0,
                showOrderTip: false,
                packageType: 0,
                isSeft: 0,
                seller: {},
                isSeftPay: 0,
                current: -1,
                isLoading: false,
                tasteList: [],
                disFlag: true,
                chkPromise: true,
                configsData: {},
                orderData: {},
                orderList: [],
                unPayTip: '',
                openOrderChange: false,
                timer: null
            }
        },
        computed: {
            payClass() {
                if (this.orderData != null) {
                    var person = this.orderData.adult;
                    if (this.orderData.child != null) {
                        person = person + parseInt(this.orderData.child);
                    }
                    var everybodyCopies = 20;
                    if (this.configsData.EverybodyCopies != null) {
                        everybodyCopies = parseInt(this.configsData.EverybodyCopies.toString());

                        var curEverybodyCopies = 0;
                        var curEverybodySeveral = 0;
                        var chkEverybodyCopies = false;
                        this.cartList.forEach((item) => {
                            curEverybodyCopies = item.quantity;
                            curEverybodySeveral+= (item.several * item.quantity);
                            this.orderList.forEach((rowData) => {
                                if (rowData.foodId == item.foodId) {
                                    curEverybodyCopies += rowData.quantity;
                                }
                            });
                            if (item.PerMaxCopies > 0 && item.PerMaxCopies <= curEverybodyCopies) {
                                this.unPayTip = item.foodName + this.$t("orderList.timeLimit", { num: item.perMaxCopies});
                                item.unAdd = true;
                                chkEverybodyCopies = true;
                            }
                            else {
                                item.unAdd = false;
                            }
                        })

                        if (curEverybodySeveral >= (everybodyCopies * person)) {
                            this.unPayTip = this.$t("orderList.timeLimit", { num: (everybodyCopies * person) });
                            return true;
                        }

                        if (chkEverybodyCopies) {
                            return false;
                        }
                    }
                }
                this.unPayTip = '';
                return false;
            }
        },
        mounted() {
            this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
            this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
            this.isSeft = this.$route.query.isSeft;
            this.packageType = this.$route.query.packageType;
            this.isSeftPay = this.$route.query.isSeftPay;
            this.getCartList();
            this.getFoodTasteList();
            this.getConfigs();
            this.getOrderList();
            // if (this.timer != null) {
            //     clearInterval(this.timer);
            // }
            // this.timer = setInterval(() => {
            //     this.checkOrder()
            // }, 5000);
        },
        methods: {
            jumpOrderChange() {
                this.openOrderChange = false;
                this.$router.push({
                    path: '/result'
                })
            },
            checkOrder() {
               if(this.isSeft==0){
                    return;
               }
                let param = {
                    tableName: this.tableOrderInfo.tableName,
                    restaurantId: this.tableOrderInfo.restaurantId
                };
                this.$get('QRCodeOrder/GetUnpayOrderMainByTableName', param)
                    .then(response => {
                        if (response.code==200) {
                            var data = response.data;
                            if (data == null || data == '') {
                                window.clearTimeout(this.timer);
                                this.openOrderChange = true;
                            }
                        }
                    });
            },
            removeTip(index) {
                this.unPayTip = "";
            },
            getSendKitchen() {
                return this.$t('orderList.sendKitchen');
            },
            openDrawer() {
                this.open = !this.open;
                this.docked = false;
            },
            clickTaste(item) {
                if (this.tableOrderInfo.specielle == null) {
                    this.tableOrderInfo.specielle = "";
                }
                this.tableOrderInfo.specielle = this.tableOrderInfo.specielle + item.tasteName;
            },
            getOrderList() {
                let param = {
                    tableName: this.tableOrderInfo.tableName,
                    restaurantId: this.tableOrderInfo.restaurantId
                };
                this.$get('QRCodeOrder/GetUnpayOrderMainByTableName', param)
                    .then(response => {
                        if (response.code == 200) {
                            var data = response.data;
                            if (data == null || data == '') {
                                return;
                            }
                            this.orderData = data;
                            this.$get('QRCodeOrder/GetQRcodeOrderList', { orderId: data.orderId })
                                .then(result => {
                                    if (result.code == 200) {
                                        this.orderList = result.data;
                                    }
                                });
                        }
                    });
            },
            getConfigs() {
                this.$get('QRCodeBasicInfo/GetConfigs', { restaurantId: this.tableOrderInfo.restaurantId})
                    .then(response => {
                        if(response.code==200){
                            response.data.forEach((item) => {
                                this.configsData[item.configKey]= item.configValue;
			                })
                        }
                    });
            },
            getFoodTasteList() {
                this.$get('QRCodeOrder/GetFoodTasteList', { RestaurantId: this.tableOrderInfo.restaurantId,})
                    .then(response => {
                        if (response.code==200) {
                            this.tasteList = response.data;
                        } else {
                            this.$alert('The web cannot be accessed, please contact the manager!', 'Alert');
                        }
                    });
            },
            getCartList() {
                let param = {
                    RestaurantId: this.tableOrderInfo.restaurantId,
                    TableName: this.tableOrderInfo.tableName
                };
                 this.allAmount =0;
                this.$get('QRCodeOrder/GetCartList', param)
                    .then(response => {
                        if (response.code==200) {
                            this.cartList = response.data;
                            this.current = -1;
                            if (this.cartList.length == 0) {
                                this.cartShowData = [];
                                this.clear();
                                  this.$alert(this.$t("orderList.submittedTips"), this.$t("common.alert"), {
                                                type: 'info',
                                                okLabel: this.$t("common.ok"),
                                            });
                            }
                            else {
                                var total = 0;
                                this.showOrderTip = false;
                                this.cartList.forEach(function (item) {
                                    if (item.chargedOnce == 1) {
                                        total += item.price;
                                    }
                                    else {
                                        total += Math.round(item.quantity * item.price);
                                    }
                                });
                                this.allAmount = total;
                                this.cartOwerData = this.groupBy(this.cartList, (cart) => {
                                    return cart.createUser
                                });

                                this.cartShowData = this.groupBy(this.cartList, (cart) => {
                                    return cart.foodTypeName
                                });
                            }
                        } else {
                            this.clear();
                            this.showOrderTip = true;
                        }
                    });
            },
            selectOwerCartlist(index, val) {
                this.current = index;
                let list = [];
                if (val != null) {
                    list = val;
                }
                else {
                    list = this.cartList;
                }
                if (list.length > 0) {
                    var total = 0;
                    list.forEach(function (item) {
                        total += Math.round(item.quantity * item.price);
                    });
                    this.allAmount = total;

                    this.cartShowData = this.groupBy(list, (cart) => {
                        return cart.foodTypeName
                    });
                }
            },
            groupBy(list, fn) {
                const groups = {};
                list.forEach(function (o) {
                    const group = JSON.stringify(fn(o));
                    groups[group] = groups[group] || [];
                    groups[group].push(o);
                });
                return groups;
            },
            getImgUrl(image,w=0) {
                if (image == undefined || image == 'undefined' || image == null|| image == '') {
                    return '../static/img/default.png';
                }
                if(w==0){
                    return this.global.baseUrl + "uploads/" + image
                }
                return  this.global.baseUrl+"api/images/"+w+"/"+ image
            },
            refresh() {
                this.getCartList();
                this.$toast.success('Successfully refresh!');
            },
            jumpBack() {
                this.clear();
                this.$router.go(-1);
            },
            jumpOrderLink() {
                this.open = false;
                this.docked = true;
                this.$router.push({
                    path: '/orderList', query: {
                        packageType: this.packageType,
                        isSeft: this.isSeft,
                        isBackMain: false,
                    }
                })
            },
            cartOpration(item, oprationType) {
                switch (oprationType) {
                    case 'add':
                        this.addToCart(item);
                        break;
                    case 'reduce':
                        if (item.quantity <= 0) {
                            return;
                        }
                        this.reduceCart(item);
                        break;
                }
            },
            addToCart(item) {
                let param = {
                    RestaurantId: this.tableOrderInfo.restaurantId,
                    TableName: this.tableOrderInfo.tableName,
                    FoodId: item.foodId,
                    FoodName: item.foodName,
                    ActDiscount: item.actDiscount,
                    Price: item.price,
                    FoodImage: item.foodImage,
                    FoodTypeName: item.foodTypeName,
                    AllowDiscounts: item.allowDiscounts,
                    Quantity: 1,
                    CreateUser: this.tableOrderInfo.name,
                    CreatePhone: this.tableOrderInfo.telephone,
                    IsSeft: this.isSeft,
                    Reamrk: item.reamrk,
                };
                this.$post('QRCodeOrder/AddtoCart', param)
                    .then(response => {
                        if (response.code == 200) {
                            this.getCartList();
                        } else {
                            this.$alert('The site cannot be accessed, please contact the manager!', 'Alert');
                        }
                    });
            },
            reduceCart(item) {
                if (item.quantity <= 1) {
                    this.$confirm(this.$t("common.deleteConfirm"), this.$t("common.confirm"), {
                        type: 'warning',
                        okLabel: this.$t("common.ok"),
                        cancelLabel: this.$t("common.cancel")
                    }).then(({ result }) => {
                        if (result) {
                            let param = {
                                RestaurantId: this.tableOrderInfo.restaurantId,
                                TableName: this.tableOrderInfo.tableName,
                                FoodId: item.foodId,
                                FoodName: item.foodName,
                                ActDiscount: item.actDiscount,
                                Price: item.price,
                                FoodImage: item.foodImage,
                                FoodTypeName: item.foodTypeName,
                                AllowDiscounts: item.allowDiscounts,
                                Quantity: 1,
                                CreateUser: this.tableOrderInfo.name,
                                CreatePhone: this.tableOrderInfo.telephone,
                                IsSeft: this.isSeft,
                                Reamrk: item.reamrk,
                            };
                            this.$post('QRCodeOrder/ReduceCart', param)
                                .then(response => {
                                    if (response.code == 200) {
                                        this.getCartList();
                                    } else {
                                        this.$alert('The site cannot be accessed, please contact the manager!', 'Alert');
                                    }
                                });
                        } else {

                        }
                    });
                }
                else {
                    let param = {
                        RestaurantId: this.tableOrderInfo.restaurantId,
                        TableName: this.tableOrderInfo.tableName,
                        FoodId: item.foodId,
                        FoodName: item.foodName,
                        ActDiscount: item.actDiscount,
                        Price: item.price,
                        FoodImage: item.foodImage,
                        FoodTypeName: item.foodTypeName,
                        AllowDiscounts: item.allowDiscounts,
                        Quantity: 1,
                        CreateUser: this.tableOrderInfo.name,
                        CreatePhone: this.tableOrderInfo.telephone,
                        IsSeft: this.isSeft,
                        Reamrk: item.reamrk,
                    };
                    this.$post('QRCodeOrder/ReduceCart', param)
                        .then(response => {
                            if (response.code == 200) {
                                this.getCartList();
                            } else {
                                this.$alert('The site cannot be accessed, please contact the manager!', 'Alert');
                            }
                        });
                }
            },
            openFullscreenDialog() {
                this.openFullscreen = true;
                this.open = false;
                this.docked = true;
            },
            closeFullscreenDialog() {
                this.openFullscreen = false;
            },
            dataRefreh() {
                if (this.intervalId != null) {
                    return;
                }
                this.intervalId = setInterval(() => {
                    this.getCartList();
                }, 10000);
            },
            clear() {
                clearInterval(this.intervalId);
                this.intervalId = null;
            },
            dataLen(d) {
                if (d < 10) {
                    return "0" + d;
                }
                return d;
            },
            order() {
                if (!this.timeOutCheck()) {
                    return;
                }
                if (!this.chkPromise) {
                    this.$alert(this.$t("orderList.agreeWait"), this.$t("common.alert"), { type: 'warning', okLabel: this.$t("common.ok") });
                    return;
                }
                this.setItem('sessionStorage', 'tableOrderInfo', this.tableOrderInfo,72000000);
                let chkParam = {
                    restaurantId: this.tableOrderInfo.restaurantId,
                    tableName: this.tableOrderInfo.tableName
                };
                this.disFlag = false;
                if(this.isSeft==0){
                    this.submitOrder();
                }
                else{
                this.$get('QRCodeOrder/CheckIsBuffetPackage', chkParam)
                    .then(response => {
                        if (response.code ==200) {
                            if (response.data) {
                                this.submitOrder();
                            }
                            else {
                                this.$router.push({
                                    path: '/buffetSelect', query: {
                                    }
                                })
                                this.$alert(this.$t("orderList.selectNumber"), this.$t("common.alert"), { type: 'info', okLabel: this.$t("common.ok") });
                            }
                        } else {
                            this.$alert('The web cannot be accessed, please contact the manager!', 'Alert', { type: 'warning', okLabel: 'Sure' });
                        }
                    });
                }
            },
            submitOrder(){
                             let param = {
                                    RestaurantId: this.tableOrderInfo.restaurantId,
                                    TableName: this.tableOrderInfo.tableName
                                };
                                this.$get('QRCodeOrder/GetCartList', param)
                                    .then(result => {
                                        if (result.code==200) {
                                            this.cartList = result.data;
                                            this.showOrderTip = false;
                                                    this.isLoading = true;
                                                    var myDate = new Date();
                                                    var orderDate = myDate.getFullYear() + "-" + this.dataLen(myDate.getMonth() + 1) + "-" + this.dataLen(myDate.getDate()) + " " + this.dataLen(myDate.getHours()) + ":" + this.dataLen(myDate.getMinutes()) + ":00";
                                                     param = {
                                                        OrderType: 1,
                                                        RestaurantId: this.tableOrderInfo.restaurantId,
                                                        TableName: this.tableOrderInfo.tableName,
                                                        OrderFrom: 5,
                                                        OrderProcess:1,
                                                        DeliveryType: 1,
                                                        OrderDay: orderDate,
                                                        OrderAmount: 0,
                                                        OrderDiscount: 1,
                                                        ActualAmount: 0,
                                                        PostAmount: 0,
                                                        CouponAmount: 0,
                                                        Adult: this.tableOrderInfo.number,
                                                        State:1,
                                                        CustomerName: this.tableOrderInfo.name,
                                                        Telephone: this.tableOrderInfo.telephone,
                                                        Specielle: this.tableOrderInfo.specielle,
                                                        AccountId: 0,
                                                        PaymentType:0,
                                                        IsInvoice:0,
                                                        IsConformed:0,
                                                        OrderId: 0,
                                                        Rabatkode: '',
                                                        CreateUser:'user',
                                                        IsOrderBuffetPackage: 0,
                                                        IsSendSms:this.tableOrderInfo.isSendSms,
                                                        IsSeft:this.isSeft,
                                                    }
                                                    this.$post('QRCodeOrder/OrderQRCodeCartList', param)
                                                        .then(response => {
                                                            this.isLoading = false;
                                                            this.disFlag = true;
                                                            if (response != null) {
                                                                if (response.code == 200) {
                                                                    this.clear();
                                                                    this.$toast.success(this.$t("common.orderSuccess"));
                                                                    this.$router.push({
                                                                            path: '/orderList', query: {
                                                                                isSeft: this.isSeft,
                                                                                isSeftPay: this.isSeftPay
                                                                            }
                                                                        });
                                                                }
                                                                else {
                                                                    this.clear();
                                                                    if(response.msg.indexOf('&')>-1){
                                                                        var msgArr=response.msg.split('&');
                                                                        this.$alert(this.$t('orderList.foodMaxEachTimeOrder', { foodName:msgArr[0],num: msgArr[1] }) , this.$t("common.alert"), { type: 'warning', okLabel: this.$t("common.ok") });
                                                                    }
                                                                    else{
                                                                         this.$alert(this.$t(response.msg), this.$t("common.alert"), { type: 'warning', okLabel: this.$t("common.ok") });
                                                                    }
                                                                }
                                                            } else {
                                                                this.$alert('The site cannot be accessed, please contact the manager!', 'Alert');
                                                            }
                                                        });
                                       
                                        } else {
                                            this.disFlag = true;
                                            this.clear();
                                            this.$alert(this.$t("orderList.submittedTips"), this.$t("common.alert"), {
                                                type: 'info',
                                                okLabel: this.$t("common.ok"),
                                            });
                                            this.showOrderTip = true;
                                        }
                                    });
            },
            timeOutCheck() {
                var time = window.localStorage.getItem('timeOut');
                let that = this;
                if (time != undefined && time != null && time != "") {
                    var dateTimeStamp = new Date(time).getTime();
                    var now = new Date().getTime();
                    var diffValue = now - dateTimeStamp;
                    var minute = 1000 * 60;
                    var minC = diffValue / minute;
                    if (parseInt(minC) >= 120) {
                        this.$alert(this.$t("common.pageInvalid"), this.$t("common.alert"), {
                            type: 'warning', okLabel: this.$t("common.ok"),
                        }).then(function (result, value) {
                            that.$router.push({
                                path: '/error'
                            })
                        });
                        return false;
                    }
                    return true;
                }
                this.$alert(this.$t("common.pageInvalid"), this.$t("common.alert"), {
                    type: 'warning', okLabel: this.$t("common.ok"),
                }).then(function (result, value) {
                    that.$router.push({
                        path: '/error'
                    })
                });
                return false;
            },
        },
        created() {
            this.dataRefreh();

        },
        destroyed() {
            this.clear();
        },
        activated() {
            this.getCartList();
        },
        components: {
            'v-header': header
        }
    }
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
    .nav-title {
        text-align: center;
    }

    .mu-list {
        padding: 0px;
    }

    .mu-raised-button .mu-button-wrapper {
        padding: 0 12px;
    }

    .mu-button {
        text-transform: unset;
    }

        .mu-button .mu-icon-left {
            margin-right: 3px;
        }

    .material-icons {
        font-size: 12px;
    }

    .content {
        /*  background-image: url(../assets/image/background.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;*/
        width: 100%;
        height: 100%;
        position: absolute;
    }

    .cart-box {
        position: relative;
        margin: auto;
        background-color: #fff;
        background-size: cover;
        overflow-y: unset;
    }

    .table-info-keywords {
        color: #e53935;
        font-size: 18px;
        font-weight: 600;
        margin-left: 10px;
    }

    .table-info-list-title {
        text-align: center;
        font-size: 14px;
        color: #4fc3f7;
    }

    .cart-opration {
        float: right;
        right: 10px;
        position: absolute;
    }

    .cart-opration-btn {
        width: 36px;
        height: 36px;
        min-width: unset;
        font-size: 16px;
        color: #e53935;
        padding: 0px;
    }

    .cart-opration-quantity {
        width: 36px;
        height: 36px;
        min-width: unset;
        top: -2px;
    }

    .btn-refresh {
        position: fixed;
        right: 10px;
        background-color: #757575 !important;
        z-index: 10;
    }

    .btn-menu {
        position: fixed;
        bottom: 10px;
        left: 10px;
        background-color: #757575 !important;
    }

    .btn-continue {
        position: fixed;
        bottom: 10px;
        background-color: #757575 !important;
        left: 41%;
    }

    .btn-refresh {
        position: fixed;
        bottom: 10px;
        left: 10px
    }

    .btn-order {
        position: fixed;
        bottom: 10px;
        right: 10px
    }

    .now {
        font-size: 12px;
        color: #f01414;
        font-weight: 700;
        line-height: 24px;
        margin-right: 8px;
    }

    .old {
        font-size: 12px;
        text-decoration: line-through;
        color: #93999f;
        font-weight: 700;
        line-height: 24px;
    }

    .ower {
        position: relative;
        z-index: 9;
        padding: 10px;
        background-color: #fff;
    }

    .badge-num {
        float: left;
        width: 60px;
        height: 32px;
        margin-right: 5px;
        margin-bottom: 5px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 0 6px;
        line-height: 1.5;
        font-size: 14px;
        font-style: normal;
        background-color: #bdbdbd;
        color: #fff;
        border-radius: 3px;
        overflow: hidden;
    }

    .select {
        background-color: rgb(218, 91, 58);
    }

    .oprations {
        position: fixed;
        bottom: 0;
        right:0;
    }

        .oprations .oprations-btn {
            -webkit-box-flex: 0;
            -ms-flex: 0 0 105px;
            flex: 0 0 105px;
            width: 105px;
            float: left;
        }
            .oprations .oprations-btn .oprations-back {
                height: 48px;
                line-height: 48px;
                font-size: 12px;
                font-weight: 700;
                text-align: center;
                background-color: #bdbdbd;
                color: #fff;
                float: right;
                width:100%;
            }

            .oprations .oprations-btn .oprations-next {
                height: 48px;
                line-height: 48px;
                font-size: 12px;
                font-weight: 700;
                text-align: center;
                float: right;
                width: 100%;
            }

        .oprations .oprations-btn .oprations-next.not-enough {
            background: #2b333b;
        }

        .oprations .oprations-btn .oprations-next.enough {
            background: #00b43c;
            color: #fff;
        }

    .form-onlyread {
        pointer-events: none;
        background: #e0e0e0;
    }
</style>



// WEBPACK FOOTER //
// src/components/CartList.vue